import {AskResultViewer} from './ResultAskModel.js';
import {AnswerPoll} from './AnswerPoll.js';
import {PollModel} from './PollModel.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {Public} from './Public.js';

export class Audience {
	computeChannel(el, attr) {
		let channel = el.getAttribute(attr);
		if (!channel || ``==channel) {
			const pathParts = document.location.pathname.split(`/`);
			channel = pathParts[pathParts.length-1];
			if (``==channel && 1<pathParts.length) {
				channel=pathParts[pathParts.length-2];
			}
			if (``==channel) {
				console.log(`Audience: you MUST set a data-channel, or have a valid ending path element`);
				// alert(`data-channel invalid`);
				return;
			}
		}
		return channel;
	}
	constructor(el) {
		if (!el) {
			console.log(`pollrobot : No Polls [data-instance="Audience"] element found: not instantiating Audience`);
			return;
		}
		console.log(`Construction Polls [data-instance="Audience"] Audience in `, el);
		//document.body.addEventListener(`veedo-user-name`, evt=>this.userRegistered(evt.detail));
		this.parent = el;
		const url = el.getAttribute(`data-url`);
		const channel = this.computeChannel(el, `data-channel`);

		console.log(`PollRobot::Audience : channel=${channel}`);

		this.sse = new EventSource(`${url}${Public.Prefix}poll/sse/${channel}`);
		this.sse.addEventListener(`ping`, evt=>{
			//console.log(`ping at ${JSON.parse(evt.data).time}`);
		});
		this.sse.addEventListener(`message`, evt=>{
			// console.log(`got message, data = `, evt.data);
		});
		this.sse.addEventListener(`show-poll`, evt=>{
			this.showPoll(JSON.parse(evt.data));
		});
		this.sse.addEventListener(`close-poll`, evt=>{
			// console.log(`close-poll event received`);
			this.closePoll(JSON.parse(evt.data));
		});
		this.sse.addEventListener(`show-result`, evt=>{
			// console.log(`show-result event received)`);
			this.showResult(JSON.parse(evt.data));
		});
		this.sse.addEventListener(`close-result`, evt=>{
			// console.log(`close-result event received`);
			this.closeResult(JSON.parse(evt.data));
		});
		this.sse.onmessage = evt=>{
			console.log(`got unnamed message: `, evt);
		};

		let [css, _] = PollRobotTemplate(`Audience-css`);
		document.head.appendChild(css);

		[this.el, this.$] = PollRobotTemplate(`Audience`);
		document.body.appendChild(this.el);

		console.log(`Audience constructed, listening to ${channel}`);

		this.el.addEventListener(`pollrobot-answer-submit`, evt=>{
			this.answerSubmit(evt.detail);
		});

		document.body.addEventListener(`veedo-user-name`, evt=>this.userRegistered(evt.detail));

	}
	userRegistered(detail) {
		console.log(`PollRobot::Audience::userRegistered. detail=`, detail);
		this.userDetail = detail;
	}
	showResult(js) {
		// console.log(`Audience.showResult js=`, js);
		if (this.resultViewer && this.resultViewer.matchesJs(js)) {
			this.resultViewer.setJs(js);
		} else {
			this.clearThen( ()=> {
				this.el.innerHTML = ``;
				this.resultViewer = new AskResultViewer(this.el);
				this.resultViewer.setJs(js);
				setTimeout(()=>{
					this.el.classList.add(`showing`);
				}, 100);				
			});
		}
	}
	closeResult(js) {
		console.log(`Audience.closeResult js=`, js);
		this.resultViewer = false;
		this.clearThen();
		// if (this.resultViewer && this.resultViewer.matchesJs(js)) {
		// 	clearThen(false);
		// }
	}
	// clearThen removes whatever is showing, then executes the given callback
	clearThen(f) {
		const done = ()=>{
			this.el.removeEventListener(`transitionend`, done);
			this.el.innerHTML = ``;
			if (f) {
				f();
			}
		}
		if (this.el.classList.contains(`showing`)) {
			this.el.addEventListener(`transitionend`, done);
			this.el.classList.remove(`showing`);
		} else {
			done();
		}
	}
	answerSubmit(js) {
		js.userDetail = this.userDetail;
		console.log(`PollRobot::Audience::answerSubmit : body = `, JSON.stringify(js));
		fetch(`${this.parent.getAttribute(`data-url`)}/poll/answer/js`, {
			method: "POST",
			body: JSON.stringify(js)
		})
		.then( res=>res.json() )
		.then( js=>{
			// console.log(`received on answer submission: `, js);
			return Promise.resolve(true);
		})
		.catch(err =>{
			this.doError(err);
		});
		this.closePoll(js);
	}
	closePoll(js) {
		this.el.classList.remove(`showing`);
	}
	doError(err) {
		console.log(err);
		alert(err);
	}
	showPromise(setShowing) {
		/* catch the off-chance that we get here between the beginning of a
		   transition and the end */
		if ((setShowing && this.el.classList.contains(`showing`)) ||
		    (!setShowing && !this.el.classList.contains(`showing`))) {
			return Promise.resolve(true);
		}
		// let te = ()=>{};
		// let resolve = false;
		// let reject = false;
		// let promise = new Promise((resolve, reject) => {
		// 	this.resolve = resolve;
		// 	this.reject = reject;
		// });
		// this.el.addEventListener(`transitionend`, te);
		// te = ()=>{
		// 	this.el.removeEventListener(`transitionend`, te);
		// 	this.show_in_transition = false;
		// }
		if (setShowing) {
			this.el.classList.add(`showing`);
		} else {
			this.el.classList.remove(`showing`);
		}
		return Promise.resolve(true);
		// this.show_in_transition = true;
	}
	showPoll(js) {
		if (globalThis.config && globalThis.config.iAmRecorder) {
			return;
		}
		const model = new PollModel(0,0,js.title);
		model.fromObject(js);
		this.el.innerHTML = ``;
		new AnswerPoll(this.el, model, js.AskID);
		setTimeout(()=>{
			this.el.classList.add(`showing`);
		}, 100);
	}

	static init(dom) {
		if (!dom) dom=document;

		const audience = dom.querySelector(`[data-instance="Audience"]`);
		if (!audience) {
			console.log(`No Polls [data-instance="Audience"] found for ${document.location}`);
		} else {
			new Audience(audience);
		}
	}
}